import {Box} from "@mui/material";

import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {HomePage} from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import {getAccessToken} from "./api/AiAgentApi";
import {AuditLogsPage} from "./pages/AuditLogsPage";
import ReservationsPage from "./pages/ReservationsPage";
import MessagesPage from "./pages/MessagePage";
import React from "react";
import {Header} from "./pages/Header";
import CreateScriptForm from "./pages/CreateScriptForm";
import {DeferredActionPage} from "./pages/DeferredActionPage";
import CreateDeferredActionPage from "./pages/CreateDeferredActionPage";
import DeferredActionDetails from "./pages/DeferredActionDetailsPage";
import UserAnalyzerResultPage from "./pages/UserAnalyzerResultPage";
import UsersPage from "./pages/UsersPage";
import OpenAIRealtimeDemo from "./pages/OpenAIRealtimeDemo";
import AiTestContainersPage from "./pages/aiTestContainer/AiTestContainersPage";
import AiTestContainerDetailsPage from "./pages/aiTestContainer/AiTestContainerDetailsPage";
import OurEvenPage from "./pages/OurEvenPage";
import VectorStoragePage from "./pages/VectorStoragePage";
import {LoyaltyLogsPage} from "./pages/LoyaltyLogsPage";

function App() {
    return (
        <BrowserRouter>
            <Box
                display="flex"
                flexDirection="column"
                minHeight="100vh"
            >
                <Box flexGrow={1}>
                    { getAccessToken() ?
                        <>
                            <Header />

                            <Routes>
                                <Route path="*" element={<Navigate to="/"/>}/>
                                <Route path="/" element={<HomePage/>}/>
                                <Route path="/realtime" element={<OpenAIRealtimeDemo/>}/>
                                <Route path="/users" element={<UsersPage/>}/>
                                <Route path="/messages" element={<MessagesPage/>}/>
                                <Route path="/audit-logs" element={<AuditLogsPage/>}/>
                                <Route path="/reservations" element={<ReservationsPage/>}/>
                                <Route path="/deferred-actions" element={<DeferredActionPage/>}/>
                                <Route path="/deferred-actions/details" element={<DeferredActionDetails/>}/>
                                <Route path="/create-script" element={<CreateScriptForm/>}/>
                                <Route path="/scripts/:scriptId/update" element={<CreateScriptForm/>}/>
                                <Route path="/create-deferred-action" element={<CreateDeferredActionPage/>}/>
                                <Route path="/users/:userId/analyzer" element={<UserAnalyzerResultPage />} />
                                <Route path="/ai-test-containers" element={<AiTestContainersPage />} />
                                <Route path="/ai-test-containers/:id" element={<AiTestContainerDetailsPage />} />
                                <Route path="/our-events" element={<OurEvenPage />} />
                                <Route path="/vector-storage" element={<VectorStoragePage />} />
                                <Route path="/loyalty-logs" element={<LoyaltyLogsPage />} />
                            </Routes>
                        </>
                        : <>
                            <Routes>
                                <Route path="*" element={<Navigate to="/login"/>}/>
                                <Route path="/login" element={<LoginPage/>}/>
                            </Routes>
                        </>
                    }
                </Box>
            </Box>
        </BrowserRouter>
    );
}

export default App;
